import { useBusinessPreferences } from "hooks/usePreferences";
import { formatPhoneForDisplay } from "../../../../utils/phoneUtils";

/**
 * Custom phone number cell renderer that formats phone numbers according to business preferences
 * Uses context-based preferences for instant loading (no delay)
 */
const PhoneNumberCell = ({ value }) => {
    const { preferences } = useBusinessPreferences();

    if (!value) return null;

    // Use the utility function to format the phone number
    // Preferences are immediately available via context, no loading delay
    const { displayText } = formatPhoneForDisplay(value, preferences);

    return displayText;
};

export const validSupplierColumns = [
    {
        Header: 'Supplier Name',
        accessor: 'supplierName',
        enableFilter: true
    },
    {
        Header: 'Phone',
        accessor: 'phone1',
        type: 'number',
        enableFilter: true,
        Cell: PhoneNumberCell
    },
    {
        Header: 'Email',
        accessor: 'email',
        enableFilter: true
    },
    {
        Header: 'Address',
        accessor: 'address'
    }
]